import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  Input,
  Optional,
  Output
} from "@angular/core";
import {KEYBOARD_KEY_CODE_PRESSED} from "../../../providers";
import {Observable} from "rxjs";
import {DestroyStreamService} from "../../../services";
import {takeUntil} from "rxjs/operators";
import {KEYBOARD_ACTIONS} from "../../../enums";

@Component({
  selector: 'int-process-switch, [intProcessSwitch]',
  templateUrl: './int-process-switch.component.html',
  styleUrls: ['./int-process-switch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DestroyStreamService
  ]
})
export class IntProcessSwitchComponent {
  @Input() checked: boolean | null = null;
  @Input() process: boolean | null = null;
  @Input() disabled: boolean | null = false;

  @Output() onChange = new EventEmitter<boolean>();

  isFocused = false;

  constructor(
    private readonly destroy$: DestroyStreamService,
    @Optional()
    @Inject(KEYBOARD_KEY_CODE_PRESSED) private readonly keyPressedStream$: Observable<number>
  ) {
    this.keyPressedStream$.pipe(takeUntil(this.destroy$)).subscribe((key) => {
      if(this.isFocused && !this.process && key === KEYBOARD_ACTIONS.ENTER) {
        this.onChange.emit(!!this.checked);
      }
    })
  }

  get isChecked() {
    return Boolean(this.checked);
  }

  get loaderColor() {
    return 'var(--int-process-switch-loader-color, var(--loader-color, #ddd))'
  }

  @HostBinding('attr.data-state') get _state() {
    return this.process ? 'process' : this.checked ? 'checked' : '';
  }
  @HostBinding('attr.data-disabled') get _d() {
    return Boolean(this.disabled) ? 'disabled' : 'none';
  }
  @HostBinding('attr.tabindex') get _ti() {
    return '0';
  }
  @HostBinding('disabled') get _dis() {
    return Boolean(this.disabled)
  }

  @HostListener('focus') private _onFocus() {
    this.isFocused = true;
  }
  @HostListener('blur') private _onBlur() {
    this.isFocused = false;
  }
  @HostListener('click') private _onClick() {
    if(this.disabled) {
      return;
    }
    this.onChange.emit(!!this.checked);
  }
}
